import dayjs from 'dayjs';
export const toPhoneCall = (mobile: number | string) => {
  const url = `tel:${mobile}`;
  window.location.href = url;
};

/**
 * 动态设置css全局变量实现旋转
 * transform: rotate(var(--image-rotate))
 * @param deg 旋转角度
 * @param prop css变量, 默认'--image-rotate'
 */
export const setRotate = (deg: string, prop = '--image-rotate') => {
  let rotate = document.documentElement.style.getPropertyValue(prop) || '0deg';
  if (typeof deg === 'string') {
    rotate = deg;
  } else {
    rotate = parseInt(rotate) + 90 + 'deg';
  }
  document.documentElement.style.setProperty(prop, rotate);
};
//设置一年有多少周
export function setweekOption(year) { //传入年份,字符串类型年份,'2020'
  year = new Date(year).getFullYear()
  let days = getDay(year || new Date().getFullYear())
  let weeks = {};
  for (let i = 0; i < days.length; i++) {
      let weeksKeyLen = Object.keys(weeks).length;
      let daySplit = days[i].split('_');
      if (weeks[weeksKeyLen] === undefined) {
          weeks[weeksKeyLen + 1] = [daySplit[0]]
      } else {
          if (daySplit[1] == '1') {
              weeks[weeksKeyLen + 1] = [daySplit[0]]
          } else {
              weeks[weeksKeyLen].push(daySplit[0])
          }
      }
  }
  let option = []
  let weeksKeyLen = Object.keys(weeks).length;
  for (let i = 1; i < weeksKeyLen + 1; i++) {
      let obj:any = {};
      obj.year = year
      obj.week = "第" + i + "周" 
      obj.md = weeks[i][0] + '-' + weeks[i][weeks[i].length - 1] 
      obj.s = weeks[i][0]
      obj.e = weeks[i][weeks[i].length - 1] 
      obj.text = "第" + i + "周" + '(' + weeks[i][0] + '-' + weeks[i][weeks[i].length - 1] + ')';
      obj.value = i;
      option.push(obj)

  }  
  option = option.sort((a,b)=>{
    return b.value-a.value
  })
  return option;
}
export function getDay(year) {
  var dates = [];
  let nowYear = dayjs().year()
  if(nowYear == year) {
    const curMonth = new Date().getMonth()+1;
    dates = formatDates(year,curMonth,true)
  }else{
    dates = formatDates(year,12,false)
}
  return dates;
}
export function formatDates(year,curMonth,status) {
  var dates = [];
  for (let i = 1; i <= curMonth; i++) {
    const curDate = new Date().getDate();
    let data = (i == curMonth&&status)?curDate :new Date(year, i, 0).getDate()
    for (let j = 1; j <= data; j++) {
        dates.push(formatNumber(i) + '.' + formatNumber(j) + '_' + new Date([year, formatNumber(i), formatNumber(j)].join('-')).getDay()) //返回当年所有日期（带星期数）
    }
}
return dates;
}
export function formatNumber(n) {
  return n.toString().length > 1 ? n : '0' + n
}
/**
 * 将url参数解析成对象
 * @param urlSearch ?xxx
 * @returns {{}}
 */
export function urlTrsJson(urlSearch){
  if (!urlSearch) return {}
  const json = {}
  const index = urlSearch[0] === '?' ? 1 : 0
  const arr = urlSearch.substring(index).split('&')
  arr.forEach(function (item) {
    const tmp = item.split('=')
    json[tmp[0]] = decodeURIComponent(tmp[1])
  })
  return json
}